import { cssTransition } from "react-toastify";

const FadeInAndOut = cssTransition({
  enter: "animate__animated animate__fadeInUp",
  exit: "animate__animated animate__fadeOutDown",
});

export { FadeInAndOut };
